import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import LoyaltyCard from "@/components/LoyaltyCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicLoyaltyCard() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    axios.get(`${API}/public/loyalty/${id}`)
      .then((r) => setData(r.data))
      .catch(() => setNotFound(true));
  }, [id]);

  if (notFound) return <div className="min-h-screen grid place-items-center text-slate-400">Carte de fidélité introuvable</div>;
  if (!data) return <div className="min-h-screen grid place-items-center text-slate-400">Chargement...</div>;

  return (
    <div className="min-h-screen bg-slate-100 grid place-items-center p-4">
      <LoyaltyCard loyalty={data.loyalty} settings={data.settings} />
    </div>
  );
}
